import { PermissionUserOption } from '../keys/permissionUser.interface';
import { PermissionBaseType } from '../models/permissionBaseType.enum';
import { PermissionOption } from '../models/permissionOption.interface';

export const PermissionCommon: PermissionOption[] = [
  { code: 'P134', option: PermissionUserOption.USER_DELETE, permissions: ['common.intercom.help'] },
  {
    type: PermissionBaseType.FLAG,
    code: 'F101',
    option: PermissionUserOption.USER_COMMON_FLAG_LOG_GRPC,
    permissions: ['pu_log_grpc_request'],
  },
];
